import { api } from './api';

export interface PipelineEtapa {
  id: number;
  tenantId: number;
  nombre: string;
  descripcion?: string;
  orden: number;
  probabilidadDefault: number;
  color: string;
  isActive: boolean;
  isFinal: boolean;
}

export interface Oportunidad {
  id: number;
  tenantId: number;
  leadId?: number;
  clienteId?: number;
  nombre: string;
  nombreContacto: string;
  emailContacto?: string;
  telefonoContacto?: string;
  empresaContacto?: string;
  cargoContacto?: string;
  direccionContacto?: string;
  origen: string;
  fuente?: string;
  descripcion?: string;
  etapaId: number;
  valor: number;
  probabilidad: number;
  fechaCierreEstimada?: string;
  fechaCierreReal?: string;
  sucursalId?: number;
  tipoOportunidad?: 'nuevo_cliente' | 'upsell' | 'renovacion' | 'cross_sell' | 'referido' | 'otro';
  competencia?: string;
  usuarioAsignadoId: number;
  estado: 'activa' | 'ganada' | 'perdida' | 'cancelada';
  motivoPerdida?: string;
  notas?: string;
  etapa?: PipelineEtapa;
  lead?: {
    id: number;
    nombre: string;
    email?: string;
  };
  cliente?: {
    id: number;
    nombre: string;
    email?: string;
  };
  sucursal?: {
    id: number;
    name: string;
  };
  usuarioAsignado?: {
    id: number;
    name: string;
    email: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface OportunidadCreate {
  leadId?: number;
  clienteId?: number;
  nombre: string;
  nombreContacto: string;
  emailContacto?: string;
  telefonoContacto?: string;
  empresaContacto?: string;
  cargoContacto?: string;
  direccionContacto?: string;
  origen: string;
  fuente?: string;
  descripcion?: string;
  etapaId: number;
  valor: number;
  probabilidad?: number;
  fechaCierreEstimada: string;
  sucursalId?: number;
  tipoOportunidad?: 'nuevo_cliente' | 'upsell' | 'renovacion' | 'cross_sell' | 'referido' | 'otro';
  competencia?: string;
  usuarioAsignadoId?: number;
  notas?: string;
}

export interface OportunidadUpdate {
  nombre?: string;
  nombreContacto?: string;
  emailContacto?: string;
  telefonoContacto?: string;
  empresaContacto?: string;
  cargoContacto?: string;
  direccionContacto?: string;
  origen?: string;
  fuente?: string;
  descripcion?: string;
  etapaId?: number;
  valor?: number;
  probabilidad?: number;
  fechaCierreEstimada?: string;
  fechaCierreReal?: string;
  sucursalId?: number;
  tipoOportunidad?: 'nuevo_cliente' | 'upsell' | 'renovacion' | 'cross_sell' | 'referido' | 'otro';
  competencia?: string;
  usuarioAsignadoId?: number;
  estado?: 'activa' | 'ganada' | 'perdida' | 'cancelada';
  motivoPerdida?: string;
  notas?: string;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const oportunidadService = {
  getAll: async (
    page = 1,
    limit = 20,
    search?: string,
    estado?: string,
    etapaId?: number,
    usuarioAsignadoId?: number
  ): Promise<PaginatedResponse<Oportunidad>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    if (estado) params.append('estado', estado);
    if (etapaId) params.append('etapaId', etapaId.toString());
    if (usuarioAsignadoId) params.append('usuarioAsignadoId', usuarioAsignadoId.toString());
    
    const response = await api.get<PaginatedResponse<Oportunidad>>(`/crm/oportunidades?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { oportunidad: Oportunidad; actividades: any[] } }> => {
    const response = await api.get<{ data: { oportunidad: Oportunidad; actividades: any[] } }>(`/crm/oportunidades/${id}`);
    return response.data;
  },

  create: async (data: OportunidadCreate): Promise<{ data: { oportunidad: Oportunidad } }> => {
    const response = await api.post<{ data: { oportunidad: Oportunidad } }>('/crm/oportunidades', data);
    return response.data;
  },

  update: async (id: number, data: OportunidadUpdate): Promise<{ data: { oportunidad: Oportunidad } }> => {
    const response = await api.put<{ data: { oportunidad: Oportunidad } }>(`/crm/oportunidades/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/crm/oportunidades/${id}`);
    return response.data;
  },

  getPipelineEtapas: async (): Promise<{ data: { etapas: PipelineEtapa[] } }> => {
    const response = await api.get<{ data: { etapas: PipelineEtapa[] } }>('/crm/oportunidades/pipeline/etapas');
    return response.data;
  }
};
